import Control from "../../../../../../common/Controls/Control";
import useRCPROQuestion from "./useRCPROQuestion";

const RCPROHygiene = ({ company }) => {
  const { updateRcproData, onBlur, errors, inputsConfig, formState } =
    useRCPROQuestion({ company });
  return (
    <div>
      <Control
        label={inputsConfig.hygieneTypePrestations.label}
        type="checkBtnList"
        name="hygieneTypePrestations"
        value={company.RCPRO.hygieneTypePrestations}
        change={updateRcproData}
        error={errors}
        labelClassname="w-100"
        inputGroupStyle={{ width: "100%" }}
        btnInline
        datas={inputsConfig.hygieneTypePrestations.datas}
        dataIndex="id"
        dataLabel="name"
        onBlur={onBlur}
        required
        info={<>Plusieurs réponses possibles</>}
      />
      <Control
        label={inputsConfig.hygieneCosmetiquesSousCertification.label}
        type="btnList"
        name="hygieneCosmetiquesSousCertification"
        value={company.RCPRO.hygieneCosmetiquesSousCertification}
        change={updateRcproData}
        error={errors}
        labelClassname="w-100"
        inputGroupStyle={{ width: "100%" }}
        btnInline
        datas={inputsConfig.hygieneCosmetiquesSousCertification.datas}
        dataIndex="id"
        dataLabel="name"
        onBlur={onBlur}
        required
      />
      <Control
        label={inputsConfig.hygieneEmploiPersonnelMedical.label}
        type="btnList"
        name="hygieneEmploiPersonnelMedical"
        value={company.RCPRO.hygieneEmploiPersonnelMedical}
        change={updateRcproData}
        error={errors}
        labelClassname="w-100"
        inputGroupStyle={{ width: "100%" }}
        btnInline
        datas={inputsConfig.hygieneEmploiPersonnelMedical.datas}
        dataIndex="id"
        dataLabel="name"
        onBlur={onBlur}
        required
      />
      <Control
        label={inputsConfig.hygieneActesSousAutorisation.label}
        type="btnList"
        name="hygieneActesSousAutorisation"
        value={company.RCPRO.hygieneActesSousAutorisation}
        change={updateRcproData}
        error={errors}
        labelClassname="w-100"
        inputGroupStyle={{ width: "100%" }}
        btnInline
        datas={inputsConfig.hygieneActesSousAutorisation.datas}
        dataIndex="id"
        dataLabel="name"
        onBlur={onBlur}
        required
      />
    </div>
  );
};

export default RCPROHygiene;
